module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_feeling04-0b91268b2de3c14c4436ecdee515d6e5.svg";